module.exports = __webpack_public_path__ + "img/hood edges length.5b0f58a9.png";